export enum DriverStatuses {
  Active = "Active",
  Inactive = "Inactive "
}

export const DRIVER_STATUSES_LIST = [
  { label: "Active", value: DriverStatuses.Active, backgroundColor: "#16C350" },
  {
    label: "Inactive",
    value: DriverStatuses.Inactive,
    backgroundColor: "#A8A8BB"
  }
];
